import { axiosAjax } from './common'
import { enableHome } from '../config'
export default {
	loginSSO(params, notAlert) {
		return axiosAjax(`/auth/pw_sso/${params.token}`, 'post', {}, !!notAlert)
	},
	// CloudFlux SSO 登录
	loginCFSSO(params, notAlert) {
		return axiosAjax(`/auth/cf_sso/${params.token}`, 'post', {}, !!notAlert)
	},
	// account login
	login(params) {
		console.log('post data:', params)
		return axiosAjax('/auth/login', 'post', params)
	},
	// 注册账号
	register(params) {
		console.log('post data:', params)
		return axiosAjax('/auth/register', 'post', { data: params })
	},
	// account logout
	logout() {
		return axiosAjax('/auth/logout', 'post', {})
	},
	// reset password
	resetPassword(params) {
		return axiosAjax('/auth/reset_passwd', 'post', { data: params })
	},
	// compel change password
	compelChangePassword(params) {
		return axiosAjax('/current_account/change_password', 'post', { data: params })
	},
	// get current account
	getCurrent() {
		return axiosAjax('/current_account')
	},
	// get one account info
	getSuchAccount(id) {
		return axiosAjax('/account/' + id)
	},
	// change current account info
	updateAccount(params) {
		return axiosAjax('/current_account', 'patch', params)
	},
	// 修改头像
	changeAvatar(params) {
		return axiosAjax('/file', 'post', { data: params })
	},
	// get mfa secret string
	getMfaSecret() {
		return axiosAjax('/mfa/secret')
	},
	// open or close account mfa
	postMfaCode(params) {
		return axiosAjax('/account/mfa', 'post', params)
	},
	// 验证mfa
	verifyMfa(params) {
		return axiosAjax('/auth/mfa', 'post', { data: params })
	},
	// get verify code
	getCode() {
		return axiosAjax('/current_account/send_verify_sms', 'post', {})
	},
	// verify phone number
	verifiCode(params) {
		return axiosAjax('/current_account/verify_mobile', 'post', params)
	},
	// 忘记密码发送重置密码邮件
	forgotPassword(params) {
		return axiosAjax('/auth/reset_passwd_mail', 'post', { data: params })
	},
	// 登录是否显示验证码
	showCaptcha(params) {
		return axiosAjax('/auth/show_captcha', 'get', { params: params })
	},

	// csos维护通知
	notifyBanner(params) {
		if (enableHome) {
			return axiosAjax('/v2/utils/notification_banner/csos', 'get', params, true)
		} else {
			return new Promise(function () {})
		}
	},

	// 校验是否开启SSO登录
	checkSSO(params) {
		return axiosAjax(`/auth/is_open_sso/${params.domain}`, 'get')
	},
}



// WEBPACK FOOTER //
// ./src/api/account.js